module.exports = __webpack_public_path__ + "img/boost-1023.540d6d9.png";